<template>
  <AuthLayout :current-step="currentStep" :steps-count="2" many-steps>
    <CompleteContainer v-model="currentStep" />
  </AuthLayout>
</template>

<script>
  import AuthLayout from '@/layouts/Auth';
  import CompleteContainer from '@/containers/auth/Complete';

  export default {
    name: 'Complete',
    components: { AuthLayout, CompleteContainer },
    data() {
      return {
        currentStep: 1,
      };
    },
    created() {
      if (this.$route.query?.step) {
        this.currentStep = this.$route.query?.step;
      }
    },
  };
</script>
